// test704
(704 && 0);
